import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { debounce } from 'lodash';
import { useMemo, useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';

interface ISafTableSearchProps {
    isLoading: boolean;
    onChange: (searchValue: string) => void;
};

export const SafTableSearch = ({
    isLoading,
    onChange,
}: ISafTableSearchProps) => {

    const [searchValue, setSearchValue] = useState<string>('');


    const handleDebounceChange = useMemo(() => {
        return debounce((value) => {
            onChange(value);
        }, 500);
    }, [onChange]);

    const handleClearSearch = () => {
        setSearchValue('');
        onChange('');
    };


    return (
        <InputGroup>
            <Form.Control type="text" placeholder="Search" value={searchValue} onChange={(e) => {
                setSearchValue(e.target.value);

                if (!isLoading) {
                    handleDebounceChange(e.target.value);
                }
            }}
            />
            <Button variant="danger" disabled={searchValue === ''} onClick={handleClearSearch}>
                <FontAwesomeIcon icon={faTimesCircle} />
            </Button>
        </InputGroup>
    );
};
